import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoprayagrajcab() {



const cardData = {
  keyword: " Mumbai to Prayagraj Cab Booking  ",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai to Prayagraj cab services, ensuring a smooth and hassle-free journey for business trips, family travel, and pilgrimage tours. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Mumbai to Prayagraj convenient and stress-free. The journey covers approximately 1,200–1,250 km via NH44, typically taking 20–22 hours depending on traffic and road conditions. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai to Prayagraj cab travel.",

topPlaces: [
  {
    title: "Triveni Sangam",
    description: "Triveni Sangam is the confluence of the Ganga, Yamuna, and mythical Saraswati rivers and a major pilgrimage site in Prayagraj. Travelers from Mumbai can reach the Sangam comfortably by cab, participate in holy dips, and experience the spiritual atmosphere that attracts devotees from across India."
  },
  {
    title: "Allahabad Fort",
    description: "Allahabad Fort is a historic fort built by Emperor Akbar on the banks of the Yamuna River. Visitors traveling from Mumbai can explore the fort’s architecture, walk along its ramparts, and enjoy panoramic views of the river and city."
  },
  {
    title: "Anand Bhavan",
    description: "Anand Bhavan is the ancestral home of the Nehru family and a museum showcasing India’s freedom struggle. Travelers from Mumbai can reach the site by cab, explore its galleries, and learn about the legacy of Jawaharlal Nehru and Indian history."
  },
  {
    title: "Khusro Bagh",
    description: "Khusro Bagh is a sprawling garden and historical site in Prayagraj, housing the tombs of Mughal royalty. Visitors traveling by cab from Mumbai can stroll through the serene gardens, admire Mughal architecture, and enjoy peaceful sightseeing."
  },
  {
    title: "All Saints Cathedral",
    description: "All Saints Cathedral is a prominent Anglican church in Prayagraj known for its Gothic architecture and stained-glass windows. Travelers from Mumbai can visit the cathedral comfortably by cab and experience the architectural beauty and serene environment."
  },
  {
    title: "Minto Park",
    description: "Minto Park is a historical site and public garden commemorating British-era events. Travelers using a cab from Mumbai can enjoy walks, photography, and learn about the historical significance of the park."
  },
  {
    title: "Chandra Shekhar Azad Park",
    description: "Chandra Shekhar Azad Park is a large urban park named after the famous freedom fighter. Visitors from Mumbai can reach the park by cab, enjoy green spaces, jogging tracks, and historical monuments within the park."
  },
  {
    title: "Patalpuri Temple",
    description: "Patalpuri Temple is a sacred underground temple at the Sangam, attracting pilgrims year-round. Travelers from Mumbai can visit comfortably by cab, witness rituals, and experience the spiritual ambiance of Prayagraj."
  },
  {
    title: "Aminabad Market",
    description: "Aminabad Market is a bustling shopping area in Prayagraj offering local goods, handicrafts, and street food. Visitors from Mumbai can explore the market easily by cab and experience the city’s vibrant culture."
  },
  {
    title: "All Saints Church",
    description: "All Saints Church is another historical and architectural landmark in Prayagraj. Travelers using cab services from Mumbai can visit the church to appreciate its Gothic architecture, peaceful surroundings, and cultural heritage."
  }
],



services: [
{
name: "Mumbai to Prayagraj Cab Service",
description: "Mumbai to Prayagraj cab service offers a reliable and comfortable long-distance travel option for devotees, tourists, and business travelers. Prayagraj, known for the sacred Triveni Sangam and Kumbh Mela, attracts thousands of visitors throughout the year. This service is ideal for those who prefer a private and flexible road journey from Mumbai to Prayagraj. The route covers multiple states with well-connected highways, ensuring a smooth and continuous drive. Professional drivers experienced in long-distance travel ensure safety, proper rest stops, and timely arrival. Customers can choose from sedan, SUV, and premium vehicles based on their travel needs and group size. Doorstep pickup from Mumbai and drop anywhere in Prayagraj ensures complete convenience. With transparent pricing, easy booking, and 24x7 availability, this cab service guarantees a hassle-free and comfortable journey."
},
{
name: "Mumbai to Prayagraj Taxi",
description: "Mumbai to Prayagraj taxi service provides dependable and comfortable transportation for long-distance journeys. This service is perfect for travelers who prefer a private cab with flexible travel timing. Vehicles are well-maintained with clean interiors and comfortable seating for extended travel hours. Drivers are experienced in interstate routes, ensuring safe and efficient travel. Multiple vehicle options such as sedan and SUV cater to different budgets and group sizes. Flexible pickup locations across Mumbai add convenience. It ensures a smooth and stress-free journey experience."
},
{
name: "One Way Cab Mumbai to Prayagraj",
description: "One way cab Mumbai to Prayagraj is a cost-effective solution for passengers needing a single-side drop without return charges. This service is ideal for pilgrims, relocations, and long-distance personal travel. Customers benefit from competitive pricing, flexible pickup timing, and easy booking options. Professional drivers ensure safe and timely travel across highways. Multiple vehicle choices are available based on comfort and budget. Online booking with instant confirmation simplifies the process. It is an efficient and affordable travel option."
},
{
name: "Mumbai to Prayagraj Cab Booking Online",
description: "Mumbai to Prayagraj cab booking online allows customers to reserve their cab quickly with instant confirmation and flexible scheduling. Travelers can select vehicle type, pickup location, and travel date according to their needs. Transparent pricing ensures there are no hidden charges during the journey. Online platforms provide secure payment options and real-time availability. Dedicated customer support is available for assistance anytime. It is the most convenient way to plan long-distance travel. It ensures a smooth and organized booking experience."
},
{
name: "Mumbai to Prayagraj Taxi Fare",
description: "Mumbai to Prayagraj taxi fare is designed to be transparent and competitive, helping travelers plan their journey efficiently. Pricing depends on vehicle type, travel distance, and trip duration. Customers receive a detailed breakdown of costs including tolls and driver allowances where applicable. Affordable options are available for sedan, SUV, and premium vehicles. No hidden charges ensure trust and reliability. Flexible pricing options suit different budgets. It offers excellent value for long-distance interstate travel."
},
{
name: "Cheap Cab Mumbai to Prayagraj",
description: "Cheap cab Mumbai to Prayagraj offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers looking for reliable transportation for long journeys. Sedan vehicles provide economical pricing with transparent billing. Professional drivers ensure smooth and safe travel across long distances. Flexible booking options make planning easy. It is a perfect choice for affordable travel. It combines cost savings with reliability."
},
{
name: "Mumbai to Prayagraj Outstation Cab",
description: "Mumbai to Prayagraj outstation cab service provides dependable intercity travel with comfort and safety. This service is suitable for pilgrims, families, and business travelers. Vehicles are well-maintained for long-distance highway travel. Flexible travel options include one way and round trip packages. Professional drivers ensure safe navigation and timely arrival. Pickup from multiple locations across Mumbai adds convenience. It ensures a hassle-free and comfortable journey experience."
},
{
name: "Mumbai to Prayagraj SUV Taxi",
description: "Mumbai to Prayagraj SUV taxi is ideal for families and groups requiring extra space and comfort during long-distance travel. SUVs provide spacious seating and better road performance across highways. This option is suitable for journeys with luggage and multiple passengers. Professional drivers ensure safe and comfortable driving throughout the trip. It offers a premium travel experience. Perfect for group travel. It ensures a smooth and enjoyable ride."
},
{
name: "Mumbai to Prayagraj Sedan Cab",
description: "Mumbai to Prayagraj sedan cab is a popular choice for individuals, couples, and small families seeking a comfortable and economical ride. Sedans offer smooth travel, good mileage, and comfortable seating for long-distance journeys. This service is ideal for budget-friendly travel without compromising convenience. Professional drivers ensure safe and efficient driving. Flexible pickup options enhance convenience. It ensures a pleasant and comfortable journey."
},
{
name: "Private Cab Mumbai to Prayagraj",
description: "Private cab Mumbai to Prayagraj offers a personalized travel experience with exclusive vehicle usage for passengers. Travelers can customize routes, stops, and travel schedules according to their preferences. This ensures a relaxed and stress-free journey across long distances. Professional drivers provide safe and reliable service with complete privacy. Comfortable seating and premium service enhance the experience. It is ideal for private and luxury travel. It guarantees flexibility and comfort."
},
{
name: "AC Taxi Mumbai to Prayagraj",
description: "AC taxi Mumbai to Prayagraj ensures a comfortable journey in air-conditioned vehicles for long-distance interstate travel. This service provides a cool and pleasant environment throughout the journey. Clean interiors and well-maintained AC systems enhance passenger comfort. Suitable for families, tourists, and business travelers. Flexible booking options make travel planning easy. Professional drivers ensure timely service. It guarantees a relaxing and smooth journey experience."
}
],

tableData: [
["Mumbai to Prayagraj Cab Service","Mumbai to Prayagraj Taxi"],
["One Way Cab Mumbai to Prayagraj","Mumbai to Prayagraj Cab Booking Online"],
["Mumbai to Prayagraj Taxi Fare","Cheap Cab Mumbai to Prayagraj"],
["Mumbai to Prayagraj Outstation Cab","Mumbai to Prayagraj SUV Taxi"],
["Mumbai to Prayagraj Sedan Cab","Private Cab Mumbai to Prayagraj"],
["AC Taxi Mumbai to Prayagraj","Mumbai to Prayagraj Cab Service"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Long Distance Cab Booking",
    WhyChoosedescription: "Velocity Cabs offers dependable Mumbai to Prayagraj cab booking for a smooth and comfortable long-distance journey, ideal for family travel, religious trips, and business travel."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on long highway routes from Mumbai to Prayagraj, ensuring safe driving, proper navigation, and timely travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Mumbai to Prayagraj cab bookings. Customers receive complete fare details including toll charges and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Mumbai to Prayagraj cab service operates 24/7. Whether you plan early departure or overnight travel, we ensure reliable service anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, and multi-day travel plans between Mumbai and Prayagraj."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, and group travel."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai to Prayagraj cab bookings due to punctual drivers, clean vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai to Prayagraj cab booking?", answer: "Yes, Velocity Cabs provides reliable cab services from Mumbai to Prayagraj for one-way and round-trip travel." },
  { question: "How far is Prayagraj from Mumbai?", answer: "The distance between Mumbai and Prayagraj is approximately 1350 to 1450 km and travel time is around 22 to 26 hours depending on route and traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Prayagraj cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services from Mumbai to Prayagraj." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Mumbai to Prayagraj cabs online or through phone booking." },
  { question: "Is overnight travel possible?", answer: "Yes, our drivers are experienced in handling long-distance overnight journeys safely." },
  { question: "Is advance booking required?", answer: "Yes, advance booking is highly recommended for long-distance routes like Mumbai to Prayagraj." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Sharma",
    feedback:
      "A long but very comfortable journey from Mumbai to Prayagraj. The cab was well-maintained, and the ride remained smooth and stress-free throughout the trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sunita Verma",
    feedback:
      "The Mumbai to Prayagraj cab service was reliable and well-organized. The vehicle was clean, the drive was steady, and the entire travel experience felt safe and comfortable.",
    rating: 5
  }
];






















const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const mumbaiPrayagrajCabJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mumbai to Prayagraj Cab Booking | Velocity Cabs",
  "description": "Book a private cab from Mumbai to Prayagraj for comfortable outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mumbai to Prayagraj Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Cab from Mumbai to Prayagraj",
        "description": "Private cab from Mumbai to Prayagraj for one-way travel with AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Mumbai to Prayagraj Cab",
        "description": "Comfortable round-trip cab service from Mumbai to Prayagraj with private AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};





  return (
    <div>
      <Helmet>
  <title>Mumbai to Prayagraj Cab Booking | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Mumbai to Prayagraj for comfortable outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiPrayagrajCabJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/99.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoprayagrajcab;